import script from "./MailSend.vue?vue&type=script&setup=true&lang=ts"
export * from "./MailSend.vue?vue&type=script&setup=true&lang=ts"

import "./MailSend.vue?vue&type=style&index=0&id=0cb8e4af&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cb8e4af"]])

export default __exports__